import requestFactory from 'superagent-promise';
import superagent from 'superagent';
import promise from 'promise';
import config from '../config';
import _ from 'lodash';
import InternetBankingContentStore from '../stores/InternetBankingContentStore';
import AppStore from '../stores/AppStore';
import BrowserUtils from './BrowserUtils';
import GenericMapper from './GenericMapperUtils';

const request = requestFactory(superagent, promise);

const Api = {
  options: {
    apiVersion: '0.8',
    contentType: 'application/json',
  },

  get(url) {
    const req = request.get(url);

    return _.extend({}, req, {
      setupWith: (options) => req.use(this.setupApi(options)),
    });
  },

  setupApi(options) {
    const opts = _.extend({}, this.options, options);

    return (req) =>
      req
        .set('Accept', 'application/json')
        .set('Content-Type', opts.contentType)
        .set('x-bpi-version', opts.apiVersion)
        .set('x-bpi-client-context', JSON.stringify(this.clientContext()))
        .set('x-bpi-service-context', config.authentication.context);
  },

  clientContext() {
    const clientContext = {
      client: {
        userTrackingId: AppStore.getUserTrackingID(),
        appTitle: InternetBankingContentStore.get('documentTitle'),
        appPackageName: config.analytics.channelID,
        appVersionCode: config.version,
        appVersionName: config.versionName,
      },
      env: {
        platformVersion: BrowserUtils.getBrowserVersion(),
        make: BrowserUtils.getPlatform(),
        locale: BrowserUtils.getUserLocale(),
        platform: config.platform,
      },
    };

    return GenericMapper.mapObject(clientContext, {});
  },
};

export default Api;
